var _rect, _rect2, _g, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path2, _path3, _circle2, _g2, _circle3, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path4, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path5, _path6, _circle4, _rect37, _rect38, _rect39, _path7, _rect40, _rect41, _circle5, _rect42, _rect43, _circle6, _path8, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _path9, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _g3, _mask, _g4, _path10, _rect68, _g5, _path11, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileVisibleIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 386 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184.684,
    width: 29.807,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 249.688,
    width: 38.067,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.68,
    y: 20.832,
    width: 199.314,
    height: 108.815,
    rx: 2.155,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.859,
    y: 21.012,
    width: 198.955,
    height: 108.456,
    rx: 1.975,
    stroke: "#EDF2F9",
    strokeWidth: 0.359
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.811,
    cy: 120.673,
    r: 3.232,
    fill: "#EDF2F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 197.968,
    y: 96.608,
    width: 24.421,
    height: 8.619,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225.262,
    y: 96.608,
    width: 16.52,
    height: 8.619,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244.65,
    y: 96.608,
    width: 24.421,
    height: 8.619,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 197.25,
    y: 66.439,
    width: 165.556,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 197.25,
    y: 72.546,
    width: 142.213,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 201.917,
    y: 83.683,
    width: 19.752,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 197.25,
    y: 83.683,
    width: 3.591,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F9",
    d: "M368.553 29.453h1.437v1.437h-1.437zM371.067 29.453h1.437v1.437h-1.437zM373.581 29.453h1.437v1.437h-1.437z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 193.3,
    y: 43.813,
    width: 16.52,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 230.65,
    y: 43.813,
    width: 14.724,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 43.813,
    width: 15.083,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 305.344,
    y: 43.813,
    width: 33.758,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 193.3,
    y: 51.718,
    width: 18.674,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 230.65,
    y: 51.718,
    width: 17.597,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 51.718,
    width: 17.597,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 305.344,
    y: 51.718,
    width: 34.117,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 192.579,
    y: 30.885,
    width: 71.107,
    height: 5.746,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 201.557,
    y: 117.795,
    width: 47.045,
    height: 5.746,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.865 111.51l198.584-.09",
    stroke: "#D8DCE4",
    strokeOpacity: 0.5,
    strokeWidth: 0.359,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M193.3 69.311h172.021v13.288H193.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.297,
    cy: 67.878,
    r: 0.718,
    fill: "#EDF2F9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.68,
    y: 141.008,
    width: 199.314,
    height: 108.815,
    rx: 2.155,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.859,
    y: 141.187,
    width: 198.955,
    height: 108.456,
    rx: 1.975,
    stroke: "#EDF2F9",
    strokeWidth: 0.359
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.811,
    cy: 240.849,
    r: 3.232,
    fill: "#EDF2F9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 197.968,
    y: 216.783,
    width: 24.421,
    height: 8.619,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 225.262,
    y: 216.783,
    width: 16.52,
    height: 8.619,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 244.65,
    y: 216.783,
    width: 24.421,
    height: 8.619,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 197.25,
    y: 186.615,
    width: 165.556,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 197.25,
    y: 192.721,
    width: 142.213,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 201.917,
    y: 203.853,
    width: 19.752,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 197.25,
    y: 203.853,
    width: 3.591,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F9",
    d: "M368.553 149.628h1.437v1.437h-1.437zM371.061 149.628h1.437v1.437h-1.437zM373.581 149.628h1.437v1.437h-1.437z"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 193.3,
    y: 163.988,
    width: 16.52,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 230.647,
    y: 163.988,
    width: 14.724,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 267.994,
    y: 163.988,
    width: 15.083,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 305.344,
    y: 163.988,
    width: 33.758,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 193.3,
    y: 171.894,
    width: 18.674,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 230.647,
    y: 171.894,
    width: 17.597,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 267.994,
    y: 171.894,
    width: 17.597,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 305.344,
    y: 171.894,
    width: 34.117,
    height: 3.232,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 192.579,
    y: 151.061,
    width: 71.107,
    height: 5.746,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 201.557,
    y: 237.971,
    width: 47.045,
    height: 5.746,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.865 231.685l198.584-.089",
    stroke: "#D8DCE4",
    strokeOpacity: 0.5,
    strokeWidth: 0.359,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M193.3 189.486h172.021v13.288H193.3z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.297,
    cy: 188.054,
    r: 0.718,
    fill: "#EDF2F9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 223.109,
    width: 17.956,
    height: 4.309,
    rx: 1.077,
    fill: "#EDF2F9"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 115.91,
    height: 233.753,
    rx: 2.576,
    transform: "matrix(-1 0 0 1 171.266 0)",
    fill: "#F7F9FC"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 67.267,
    y: 16.744,
    width: 54.092,
    height: 3.22,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.838 96.727h1.327c.75 0 1.119-.382 1.119-.893 0-.496-.352-.787-.701-.805v-.032c.32-.075.573-.3.573-.698 0-.488-.353-.85-1.063-.85h-1.255v3.278zm.594-.496v-.96h.654c.367 0 .594.224.594.517 0 .26-.18.443-.61.443h-.638zm0-1.388v-.904h.6c.349 0 .53.184.53.437 0 .288-.234.467-.543.467h-.587zm2.343 1.884h.58V94.27h-.58v2.458zm.291-2.807c.184 0 .335-.141.335-.314 0-.174-.15-.315-.335-.315-.186 0-.336.14-.336.315 0 .173.15.314.336.314zm1.956 2.855c.72 0 1.179-.507 1.179-1.267 0-.762-.458-1.271-1.178-1.271s-1.179.509-1.179 1.27.458 1.268 1.178 1.268zm.004-.464c-.399 0-.594-.355-.594-.805 0-.45.195-.81.594-.81.392 0 .587.36.587.81 0 .45-.195.805-.587.805z",
    fill: "#0B0826"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 57.934,
    y: 34.136,
    width: 110.759,
    height: 44.11,
    rx: 2.576,
    fill: "#F0F4F9"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 148.088,
    y: 41.865,
    width: 12.879,
    height: 6.439,
    rx: 3.22,
    fill: "#E4EBF5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.75,
    cy: 45.084,
    r: 2.576,
    fill: "#fff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 158.391,
    y: 208.641,
    width: 7.727,
    height: 7.727,
    rx: 1.288,
    fill: "#E7EBF1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 158.391,
    y: 218.942,
    width: 7.727,
    height: 7.727,
    rx: 1.288,
    fill: "#E7EBF1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.242,
    cy: 11.592,
    r: 6.439,
    fill: "#EDF2F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F9",
    d: "M161.928 8.689h3.22v2.576h-3.22z"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 60.508,
    y: 6.762,
    width: 63.751,
    height: 5.152,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 60.508,
    y: 137.806,
    width: 26.08,
    height: 3.864,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 93.691,
    width: 9.981,
    height: 3.864,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 136.172,
    y: 69.228,
    width: 24.792,
    height: 3.864,
    rx: 0.966,
    fill: "#E4EBF5"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 210.891,
    width: 39.281,
    height: 3.864,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 221.195,
    width: 37.993,
    height: 3.864,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C20010",
    d: "M60.514 16.744h3.864v3.22h-3.864z"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 63.081,
    y: 41.856,
    width: 63.107,
    height: 5.152,
    rx: 0.966,
    fill: "#E4EBF5"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 63.081,
    y: 53.447,
    width: 77.596,
    height: 2.576,
    rx: 0.966,
    fill: "#E4EBF5"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 63.081,
    y: 60.856,
    width: 50.872,
    height: 2.576,
    rx: 0.966,
    fill: "#E4EBF5"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 145.532,
    width: 19.962,
    height: 2.898,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 163.242,
    width: 19.962,
    height: 2.898,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 104.965,
    width: 97.558,
    height: 2.898,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 111.401,
    width: 84.357,
    height: 2.898,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 117.52,
    width: 94.66,
    height: 2.898,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 180.949,
    width: 19.962,
    height: 2.898,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 151.651,
    width: 21.894,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 169.358,
    width: 21.894,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 60.514,
    y: 187.068,
    width: 21.894,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 84.974,
    y: 151.651,
    width: 14.811,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 84.974,
    y: 169.358,
    width: 14.811,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 84.974,
    y: 187.068,
    width: 14.811,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 102.365,
    y: 151.651,
    width: 21.894,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 102.365,
    y: 187.068,
    width: 21.894,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 126.833,
    y: 151.651,
    width: 10.947,
    height: 7.727,
    rx: 0.966,
    fill: "#EDF2F9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 34,
    width: 162,
    height: 52.744,
    rx: 3.767,
    fill: "#F0F4F9"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 34,
    width: 162,
    height: 53
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 34,
    width: 162,
    height: 52.744,
    rx: 3.767,
    fill: "#F0F4F9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    stroke: "#4D3BD7",
    strokeWidth: 14.128,
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 210.369,
    cy: 102.52,
    r: 81.236
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 210.605,
    cy: 102.756,
    r: 62.163
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 210.369,
    cy: 102.52,
    r: 41.677
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.986 66.43h.6l1.058-3.82h.038l1.058 3.82h.6l1.31-4.795h-.59l-1.002 3.906h-.047l-1.02-3.906h-.656l-1.02 3.906h-.047l-1.003-3.906h-.59l1.312 4.795zm6.486.075c.73 0 1.264-.365 1.433-.908l-.534-.15c-.14.374-.466.562-.9.562-.648 0-1.095-.42-1.12-1.19h2.61v-.234c0-1.339-.796-1.798-1.545-1.798-.974 0-1.62.768-1.62 1.873s.636 1.845 1.676 1.845zm-1.122-2.163c.038-.56.433-1.058 1.066-1.058.599 0 .983.45.983 1.058H40.35zm6.364 2.172c.627 0 .955-.337 1.068-.57h.028v.486h.552v-2.37c0-1.142-.87-1.273-1.33-1.273-.543 0-1.16.188-1.442.843l.525.187c.121-.262.41-.543.936-.543.508 0 .759.27.759.73v.02c0 .266-.272.243-.928.327-.667.087-1.395.234-1.395 1.058 0 .703.543 1.105 1.227 1.105zm.084-.496c-.44 0-.758-.197-.758-.58 0-.422.384-.553.814-.61.235-.027.862-.093.956-.205v.505c0 .45-.356.89-1.012.89zm2.573.412h.552v-2.276c0-.486.384-.842.909-.842.147 0 .3.028.337.037v-.562a5.298 5.298 0 0 0-.29-.01c-.431 0-.806.244-.937.6h-.038v-.543h-.533v3.596zm3.851.075c.73 0 1.264-.365 1.433-.908l-.534-.15c-.14.374-.466.562-.899.562-.648 0-1.096-.42-1.121-1.19h2.61v-.234c0-1.339-.796-1.798-1.545-1.798-.974 0-1.62.768-1.62 1.873s.637 1.845 1.676 1.845zm-1.121-2.163c.037-.56.433-1.058 1.065-1.058.6 0 .983.45.983 1.058h-2.048zm5.38 2.088h.534v-.552h.065c.122.196.356.627 1.05.627.898 0 1.526-.721 1.526-1.864 0-1.133-.628-1.854-1.536-1.854-.703 0-.918.431-1.04.618h-.047v-1.77h-.552v4.795zm.543-1.798c0-.805.356-1.348 1.03-1.348.703 0 1.05.59 1.05 1.348 0 .768-.357 1.377-1.05 1.377-.665 0-1.03-.562-1.03-1.377zm3.477 1.798h.552v-2.276c0-.486.384-.842.909-.842.147 0 .3.028.337.037v-.562a5.295 5.295 0 0 0-.29-.01c-.431 0-.806.244-.937.6h-.037v-.543H61.5v3.596zm3.804.075c.974 0 1.63-.74 1.63-1.854 0-1.124-.656-1.864-1.63-1.864-.974 0-1.63.74-1.63 1.864 0 1.114.656 1.854 1.63 1.854zm0-.496c-.74 0-1.077-.637-1.077-1.358 0-.721.338-1.367 1.077-1.367.74 0 1.077.646 1.077 1.367s-.337 1.358-1.077 1.358zm3.532.505c.627 0 .955-.337 1.067-.57h.028v.486h.553v-2.37c0-1.142-.871-1.273-1.33-1.273-.543 0-1.161.188-1.442.843l.524.187c.122-.262.41-.543.937-.543.508 0 .758.27.758.73v.02c0 .266-.271.243-.927.327-.667.087-1.395.234-1.395 1.058 0 .703.543 1.105 1.227 1.105zm.084-.496c-.44 0-.759-.197-.759-.58 0-.422.384-.553.815-.61.234-.027.862-.093.955-.205v.505c0 .45-.356.89-1.011.89zm3.93.487c.693 0 .927-.43 1.05-.627h.065v.552h.534v-4.795h-.553v1.77H73.9c-.122-.187-.337-.618-1.04-.618-.908 0-1.535.721-1.535 1.854 0 1.143.627 1.864 1.526 1.864zm.075-.496c-.693 0-1.049-.609-1.049-1.377 0-.758.347-1.348 1.05-1.348.673 0 1.03.543 1.03 1.348 0 .815-.366 1.377-1.03 1.377zm4.123.496c.796 0 1.32-.487 1.414-1.124h-.552c-.103.394-.431.628-.862.628-.655 0-1.077-.543-1.077-1.377 0-.815.431-1.348 1.077-1.348.487 0 .777.3.862.627h.552c-.093-.674-.665-1.124-1.423-1.124-.974 0-1.62.768-1.62 1.864 0 1.077.618 1.854 1.63 1.854zm3.28.01c.628 0 .956-.338 1.068-.572h.028v.487h.553v-2.37c0-1.142-.871-1.273-1.33-1.273-.543 0-1.161.188-1.442.843l.524.187c.122-.262.41-.543.936-.543.508 0 .76.27.76.73v.02c0 .266-.273.243-.928.327-.667.087-1.395.234-1.395 1.058 0 .703.543 1.105 1.226 1.105zm.085-.497c-.44 0-.759-.197-.759-.58 0-.422.384-.553.815-.61.234-.027.861-.093.955-.205v.505c0 .45-.356.89-1.011.89zm5.12-2.379c-.174-.51-.563-.852-1.274-.852-.759 0-1.32.431-1.32 1.04 0 .496.294.829.954.983l.6.14c.363.085.534.258.534.506 0 .31-.328.562-.843.562-.452 0-.735-.194-.834-.58l-.524.13c.129.612.632.937 1.367.937.836 0 1.405-.456 1.405-1.077 0-.5-.314-.817-.955-.974l-.534-.13c-.426-.106-.618-.25-.618-.525 0-.31.328-.534.768-.534.482 0 .681.267.777.515l.496-.14zm2.46-.805h-.767v-.862h-.553v.862h-.543v.468h.543v2.248c0 .627.506.927.974.927.206 0 .337-.037.412-.066l-.112-.496c-.047.01-.122.028-.244.028-.243 0-.477-.075-.477-.543v-2.098h.768v-.468zm.832 3.596h.552v-3.596h-.552v3.596zm.28-4.195a.386.386 0 0 0 .394-.375.386.386 0 0 0-.393-.374.386.386 0 0 0-.394.374c0 .206.178.375.394.375zm1.837 2.032c0-.628.389-.983.918-.983.512 0 .824.334.824.899v2.247h.552v-2.285c0-.918-.489-1.358-1.217-1.358-.543 0-.88.244-1.049.609h-.047v-.562h-.534v3.596h.553v-2.163zm4.756 3.587c.861 0 1.554-.394 1.554-1.32v-3.7h-.534v.571h-.056c-.121-.187-.346-.618-1.049-.618-.908 0-1.535.721-1.535 1.826 0 1.124.655 1.761 1.526 1.761.702 0 .927-.412 1.049-.609h.047v.73c0 .6-.422.872-1.002.872-.654 0-.883-.344-1.03-.543l-.44.309c.224.377.667.72 1.47.72zm-.02-1.976c-.692 0-1.048-.525-1.048-1.274 0-.73.347-1.32 1.049-1.32.674 0 1.03.543 1.03 1.32 0 .796-.365 1.274-1.03 1.274zm4.796 1.9c.499 0 .85-.264 1.058-.823l1.531-4.112-.604-.009-.992 2.866h-.038l-.993-2.866h-.599l1.33 3.615-.103.28c-.202.549-.45.6-.852.497l-.141.487c.056.028.216.066.403.066zm4.653-1.273c.973 0 1.629-.74 1.629-1.854 0-1.124-.656-1.864-1.629-1.864-.974 0-1.63.74-1.63 1.864 0 1.114.656 1.854 1.63 1.854zm0-.496c-.74 0-1.077-.637-1.077-1.358 0-.721.337-1.367 1.077-1.367.739 0 1.076.646 1.076 1.367s-.337 1.358-1.076 1.358zm4.739-1.05c0 .675-.515.984-.927.984-.459 0-.787-.337-.787-.861v-2.248h-.553v2.285c0 .918.487 1.358 1.162 1.358.543 0 .899-.29 1.067-.656h.038v.61h.552v-3.597h-.552v2.126zm1.564 1.471h.553v-2.276c0-.486.384-.842.908-.842.148 0 .3.028.337.037v-.562a5.277 5.277 0 0 0-.29-.01c-.431 0-.805.244-.936.6h-.038v-.543h-.534v3.596zm4.308 1.349h.552v-1.901h.047c.122.196.356.627 1.049.627.899 0 1.527-.721 1.527-1.864 0-1.133-.628-1.854-1.536-1.854-.703 0-.918.431-1.04.618h-.065v-.571h-.534v4.945zm.543-3.147c0-.805.356-1.348 1.03-1.348.702 0 1.049.59 1.049 1.348 0 .768-.356 1.377-1.049 1.377-.665 0-1.03-.562-1.03-1.377zm3.474 1.798h.553v-2.276c0-.486.384-.842.908-.842.148 0 .3.028.337.037v-.562a5.277 5.277 0 0 0-.29-.01c-.431 0-.805.244-.936.6h-.038v-.543h-.534v3.596zm3.805.075c.974 0 1.629-.74 1.629-1.854 0-1.124-.655-1.864-1.629-1.864s-1.63.74-1.63 1.864c0 1.114.656 1.854 1.63 1.854zm0-.496c-.74 0-1.077-.637-1.077-1.358 0-.721.337-1.367 1.077-1.367s1.077.646 1.077 1.367-.337 1.358-1.077 1.358zm4.074-3.175h-.805v-.365c0-.356.15-.543.515-.543.159 0 .253.037.309.056l.159-.478a1.283 1.283 0 0 0-.524-.093c-.515 0-1.012.309-1.012.927v.496h-.58v.468h.58v3.128h.553v-3.128h.805v-.468zm.775 3.596h.552v-3.596h-.552v3.596zm.281-4.195a.386.386 0 0 0 .393-.375.386.386 0 0 0-.393-.374.386.386 0 0 0-.394.374c0 .206.178.375.394.375zm1.836-.6h-.553v4.795h.553v-4.795zm2.52 4.87c.73 0 1.264-.365 1.432-.908l-.533-.15c-.141.374-.466.562-.899.562-.649 0-1.096-.42-1.122-1.19h2.611v-.234c0-1.339-.796-1.798-1.546-1.798-.974 0-1.62.768-1.62 1.873s.637 1.845 1.677 1.845zm-1.122-2.163c.038-.56.433-1.058 1.065-1.058.6 0 .984.45.984 1.058h-2.049zm-96.32 8.492h-.768v-.862h-.553v.862h-.543v.468h.543v2.248c0 .627.506.927.974.927.206 0 .337-.037.412-.066l-.112-.496c-.047.01-.122.028-.244.028-.243 0-.477-.075-.477-.543v-2.098h.768v-.468zm2.253 3.671c.974 0 1.63-.74 1.63-1.854 0-1.124-.656-1.864-1.63-1.864-.974 0-1.63.74-1.63 1.864 0 1.114.656 1.854 1.63 1.854zm0-.496c-.74 0-1.077-.637-1.077-1.358 0-.721.337-1.367 1.077-1.367s1.077.646 1.077 1.367-.337 1.358-1.077 1.358zm5.788.496c.974 0 1.63-.74 1.63-1.854 0-1.124-.656-1.864-1.63-1.864-.974 0-1.63.74-1.63 1.864 0 1.114.656 1.854 1.63 1.854zm0-.496c-.74 0-1.077-.637-1.077-1.358 0-.721.337-1.367 1.077-1.367s1.077.646 1.077 1.367-.337 1.358-1.077 1.358zm4.74-1.05c0 .675-.516.984-.928.984-.458 0-.786-.337-.786-.861v-2.248h-.553v2.285c0 .918.487 1.358 1.162 1.358.543 0 .899-.29 1.067-.656h.038v.61h.552v-3.597h-.552v2.126zm1.564 1.471h.553v-2.276c0-.486.384-.842.908-.842.148 0 .3.028.337.037v-.562a5.302 5.302 0 0 0-.29-.01c-.43 0-.805.244-.937.6h-.037v-.543h-.534v3.596zm7.005-3.596h.562c-.026-.723-.693-1.264-1.62-1.264-.918 0-1.64.534-1.64 1.339 0 .646.469 1.03 1.218 1.245l.59.17c.506.14.955.317.955.795 0 .525-.506.871-1.17.871-.572 0-1.077-.253-1.124-.796h-.6c.057.787.693 1.32 1.724 1.32 1.105 0 1.732-.608 1.732-1.385 0-.9-.852-1.19-1.349-1.321l-.486-.131c-.356-.094-.928-.281-.928-.796 0-.459.422-.796 1.059-.796.58 0 1.02.276 1.077.749zm3.07 0h-.767v-.862h-.553v.862h-.543v.468h.543v2.248c0 .627.506.927.974.927.206 0 .337-.037.412-.066l-.112-.496c-.047.01-.122.028-.243.028-.244 0-.478-.075-.478-.543v-2.098h.768v-.468zm1.89 3.68c.628 0 .956-.337 1.068-.57h.028v.486h.552v-2.37c0-1.142-.87-1.273-1.33-1.273-.542 0-1.16.188-1.442.843l.525.187c.122-.262.41-.543.936-.543.508 0 .759.27.759.73v.02c0 .266-.272.243-.927.327-.668.087-1.396.234-1.396 1.058 0 .703.544 1.105 1.227 1.105zm.084-.496c-.44 0-.758-.197-.758-.58 0-.422.384-.553.815-.61.234-.027.861-.093.955-.205v.505c0 .45-.356.89-1.012.89zm2.573.412h.552v-2.276c0-.486.385-.842.909-.842.147 0 .3.028.337.037v-.562a5.298 5.298 0 0 0-.29-.01c-.431 0-.806.244-.937.6h-.037v-.543h-.534v3.596zm4.242-3.596h-.768v-.862h-.552v.862h-.543v.468h.543v2.248c0 .627.506.927.974.927.206 0 .337-.037.412-.066l-.112-.496c-.047.01-.122.028-.244.028-.243 0-.478-.075-.478-.543v-2.098h.768v-.468zm3.098 2.126c0 .674-.515.983-.927.983-.46 0-.787-.337-.787-.861v-2.248h-.552v2.285c0 .918.486 1.358 1.16 1.358.544 0 .9-.29 1.068-.656h.038v.61h.552v-3.597h-.552v2.126zm1.564 2.819h.553v-1.901h.047c.122.196.356.627 1.049.627.899 0 1.526-.721 1.526-1.864 0-1.133-.627-1.854-1.536-1.854-.702 0-.917.431-1.04.618h-.065v-.571h-.534v4.945zm.544-3.147c0-.805.356-1.348 1.03-1.348.702 0 1.049.59 1.049 1.348 0 .768-.356 1.377-1.05 1.377-.664 0-1.03-.562-1.03-1.377zm5.88-.365c0-.628.39-.983.919-.983.512 0 .824.334.824.899v2.247h.552v-2.285c0-.918-.489-1.358-1.217-1.358-.543 0-.88.244-1.049.609h-.047v-.562h-.534v3.596h.553v-2.163zm4.813 2.238c.73 0 1.264-.365 1.433-.908l-.534-.15c-.14.374-.466.562-.9.562-.648 0-1.095-.42-1.12-1.19h2.61v-.234c0-1.339-.796-1.798-1.545-1.798-.974 0-1.62.768-1.62 1.873s.636 1.845 1.676 1.845zm-1.122-2.163c.038-.56.434-1.058 1.066-1.058.599 0 .983.45.983 1.058H83.59zm5.015-1.508h-.768v-.862h-.552v.862h-.543v.468h.543v2.248c0 .627.506.927.974.927.206 0 .337-.037.412-.066l-.112-.496c-.047.01-.122.028-.244.028-.243 0-.478-.075-.478-.543v-2.098h.768v-.468zm1.646 3.596h.543l.787-2.763h.056l.787 2.763h.543l1.096-3.596h-.58l-.778 2.744h-.038l-.758-2.744h-.59l-.768 2.753h-.038l-.777-2.753h-.58l1.095 3.596zm5.88.075c.975 0 1.63-.74 1.63-1.854 0-1.124-.655-1.864-1.63-1.864-.973 0-1.629.74-1.629 1.864 0 1.114.656 1.854 1.63 1.854zm0-.496c-.739 0-1.076-.637-1.076-1.358 0-.721.337-1.367 1.077-1.367s1.077.646 1.077 1.367-.337 1.358-1.077 1.358zm2.474.421h.552v-2.276c0-.486.384-.842.909-.842.147 0 .3.028.337.037v-.562a5.277 5.277 0 0 0-.29-.01c-.431 0-.806.244-.937.6h-.037v-.543h-.534v3.596zm2.453 0h.553v-1.346l.386-.358 1.346 1.704h.702l-1.631-2.06 1.519-1.536h-.684l-1.573 1.602h-.065v-2.8h-.553v4.794zm3.989.038a.422.422 0 0 0 0-.843.423.423 0 0 0-.422.421c0 .232.19.422.422.422z",
    fill: "#9DA6B4"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 157.86,
    y: 45.302,
    width: 18.837,
    height: 9.419,
    rx: 4.709,
    fill: "#4D3BD7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 171.767,
    cy: 50.012,
    r: 3.767,
    fill: "#fff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.13 51.535h1.448v-2.428h1.057l1.298 2.428h1.599l-1.455-2.662c.78-.335 1.21-1.014 1.21-1.95 0-1.362-.899-2.238-2.454-2.238H34.13v6.85zm1.448-3.592v-2.074h.977c.836 0 1.241.371 1.241 1.053 0 .68-.405 1.02-1.234 1.02h-.983zm6.965 3.692c1.27 0 2.127-.619 2.328-1.572l-1.318-.087c-.144.392-.512.596-.987.596-.712 0-1.164-.472-1.164-1.238v-.003h3.499v-.392c0-1.745-1.057-2.608-2.415-2.608-1.512 0-2.492 1.073-2.492 2.659 0 1.628.967 2.645 2.549 2.645zm-1.14-3.187c.03-.586.474-1.054 1.107-1.054.618 0 1.046.442 1.05 1.054h-2.158zm5.893 3.184c.759 0 1.25-.331 1.502-.81h.04v.713h1.35V48.07c0-1.224-1.036-1.74-2.18-1.74-1.23 0-2.04.59-2.237 1.526l1.317.107c.097-.341.402-.592.913-.592.485 0 .763.244.763.665v.02c0 .332-.351.375-1.244.462-1.017.094-1.93.435-1.93 1.582 0 1.017.726 1.532 1.706 1.532zm.408-.983c-.438 0-.753-.205-.753-.596 0-.401.331-.598.833-.669.311-.043.82-.117.99-.23v.545c0 .538-.445.95-1.07.95zm5.483.97c.83 0 1.261-.479 1.459-.907h.06v.823h1.405v-6.85h-1.422v2.575h-.043c-.191-.418-.602-.93-1.462-.93-1.127 0-2.08.877-2.08 2.643 0 1.719.913 2.645 2.083 2.645zm.452-1.134c-.7 0-1.08-.623-1.08-1.519 0-.89.374-1.502 1.08-1.502.692 0 1.08.586 1.08 1.502 0 .917-.394 1.519-1.08 1.519zm4.523 2.976c1.06 0 1.622-.541 1.913-1.37l1.997-5.687-1.509-.007-1.073 3.773h-.054l-1.063-3.773h-1.499l1.843 5.285-.084.217c-.187.482-.545.505-1.047.352l-.32 1.063c.203.087.535.147.896.147zm9.551-7.064h-.966v-1.23h-1.425v1.23h-.703v1.07h.703v2.677c-.007 1.006.679 1.505 1.712 1.461.368-.013.63-.087.773-.134l-.224-1.06c-.07.013-.22.047-.355.047-.284 0-.481-.107-.481-.502v-2.488h.966v-1.07zm3.195 5.238c1.558 0 2.528-1.067 2.528-2.649 0-1.592-.97-2.655-2.529-2.655-1.558 0-2.528 1.063-2.528 2.655 0 1.582.97 2.65 2.528 2.65zm.006-1.104c-.719 0-1.087-.658-1.087-1.555 0-.896.368-1.558 1.087-1.558.706 0 1.074.662 1.074 1.558 0 .897-.368 1.555-1.074 1.555zm5.628 1.004h1.425v-5.138h-1.425v5.138zm.716-5.8c.425 0 .773-.324.773-.722 0-.395-.348-.72-.773-.72-.421 0-.77.325-.77.72 0 .398.349.722.77.722zm3.276 2.83c.003-.662.397-1.05.973-1.05.572 0 .916.374.913 1.003v3.017h1.425v-3.271c0-1.198-.703-1.934-1.773-1.934-.763 0-1.315.375-1.545.974h-.06v-.907h-1.358v5.138h1.425v-2.97zm7.166-2.168h-.966v-1.23h-1.425v1.23h-.703v1.07h.703v2.677c-.007 1.006.679 1.505 1.712 1.461.368-.013.63-.087.773-.134l-.224-1.06c-.07.013-.22.047-.355.047-.284 0-.481-.107-.481-.502v-2.488h.966v-1.07zm3.215 5.238c1.27 0 2.127-.619 2.327-1.572l-1.317-.087c-.144.392-.512.596-.987.596-.713 0-1.164-.472-1.164-1.238v-.003h3.498v-.392c0-1.745-1.056-2.608-2.414-2.608-1.512 0-2.492 1.073-2.492 2.659 0 1.628.966 2.645 2.549 2.645zm-1.141-3.187c.03-.586.475-1.054 1.107-1.054.619 0 1.047.442 1.05 1.054h-2.157zm4.428 3.087h1.425v-2.907c0-.632.462-1.067 1.09-1.067.198 0 .469.034.603.077v-1.264a2.138 2.138 0 0 0-.449-.05c-.575 0-1.046.334-1.234.97h-.053v-.897h-1.382v5.138zm8.8-5.138h-1.508l-1.064 3.676h-.053l-1.067-3.676h-1.505l1.796 5.138h1.605l1.796-5.138zm.729 5.138h1.425v-5.138h-1.425v5.138zm.716-5.8c.425 0 .773-.324.773-.722 0-.395-.348-.72-.773-.72-.421 0-.769.325-.769.72 0 .398.348.722.769.722zm4.192 5.9c1.271 0 2.127-.619 2.328-1.572l-1.318-.087c-.144.392-.512.596-.987.596-.712 0-1.164-.472-1.164-1.238v-.003h3.499v-.392c0-1.745-1.057-2.608-2.415-2.608-1.512 0-2.492 1.073-2.492 2.659 0 1.628.967 2.645 2.549 2.645zm-1.141-3.187c.03-.586.475-1.054 1.107-1.054.619 0 1.047.442 1.051 1.054h-2.158zm5.405 3.087h1.505l.883-3.231h.064l.883 3.23h1.508l1.395-5.137h-1.438l-.783 3.432h-.043l-.843-3.432h-1.415l-.829 3.452h-.047l-.796-3.452h-1.442l1.398 5.138z",
    fill: "#0B0826"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 183.243,
    y: 20.114,
    width: 202.187,
    height: 111.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.718,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.718
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.359
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627 0 0 0 0 0.976471 0 0 0 0 0.988235 0 0 0 0.69575 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 183.243,
    y: 140.29,
    width: 202.187,
    height: 111.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.718,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.718
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.359
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627 0 0 0 0 0.976471 0 0 0 0 0.988235 0 0 0 0.69575 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 0.06,
    y: 8.06,
    width: 213.88,
    height: 104.624,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.97
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2625 0 0 0 0 0.2625 0 0 0 0 0.2625 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 166.116,
    y: 44.831,
    width: 11.302,
    height: 11.302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.471
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 214.965,
    y1: 69.311,
    x2: 214.965,
    y2: 79.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 214.965,
    y1: 189.486,
    x2: 214.965,
    y2: 199.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVisibleIllustration);
export default __webpack_public_path__ + "static/media/profile_visible_illustration.7d06662d.svg";
export { ForwardRef as ReactComponent };